import { StarFilled } from '@ant-design/icons';
import { Rate } from 'antd';
import React from 'react';
import { CSSProperties } from 'styled-components';
import styles from './style.module.scss';

type AppRateProps = {
  value: number;
  disabled?: boolean;
  defaultValue?: number;
  onChange?: (_value: number) => void;
  additionalStyles?: CSSProperties;
  allowClear?: boolean;
  allowHalf?: boolean;
  character?: React.ReactNode;
};

const AppRate: React.FC<AppRateProps> = ({
  value = 5,
  disabled = false,
  defaultValue = 5,
  onChange = () => {},
  additionalStyles = {},
  allowClear = true,
  allowHalf = false,
  character = <StarFilled />,
}) => {
  return (
    <div className={styles['app-rate-container']}>
      <Rate
        onChange={onChange}
        value={value}
        disabled={disabled}
        defaultValue={defaultValue}
        style={additionalStyles}
        allowClear={allowClear}
        allowHalf={allowHalf}
        character={character}
      />
    </div>
  );
};

export default AppRate;
